import { EVINCED_SEVERITIES, EVINCED_SEVERITIES_IDS, OptionType } from '@evinced-private/ui-common';

export type SeveritiesDisplayMode =
	(typeof SEVERITIES_DISPLAY_MODE)[keyof typeof SEVERITIES_DISPLAY_MODE];

export const SEVERITIES_DISPLAY_MODE = {
	ALL: 'all',
	CUSTOM: 'customOnly'
} as const;

export const severitiesOrder = [
	EVINCED_SEVERITIES.CRITICAL,
	EVINCED_SEVERITIES.SERIOUS,
	EVINCED_SEVERITIES.MODERATE,
	EVINCED_SEVERITIES.MINOR,
	EVINCED_SEVERITIES.NEEDS_REVIEW,
	EVINCED_SEVERITIES.BEST_PRACTICE
];

export const severityOptions: OptionType[] = [
	{ label: EVINCED_SEVERITIES.CRITICAL, value: EVINCED_SEVERITIES_IDS.CRITICAL },
	{ label: EVINCED_SEVERITIES.SERIOUS, value: EVINCED_SEVERITIES_IDS.SERIOUS },
	{ label: EVINCED_SEVERITIES.MODERATE, value: EVINCED_SEVERITIES_IDS.MODERATE },
	{ label: EVINCED_SEVERITIES.MINOR, value: EVINCED_SEVERITIES_IDS.MINOR },
	{ label: EVINCED_SEVERITIES.NEEDS_REVIEW, value: EVINCED_SEVERITIES_IDS.NEEDS_REVIEW },
	{ label: EVINCED_SEVERITIES.BEST_PRACTICE, value: EVINCED_SEVERITIES_IDS.BEST_PRACTICE }
];
